module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/wow-slider/wow-bounce/wow-bounce.component.scss
// module id = ./src/app/features/wow-slider/wow-bounce/wow-bounce.component.scss
// module chunks = main